<form [formGroup]="form" class="container-fluid container-filter" autocomplete="off">
    <div class="animated fadeIn container-listbox">

        <div class="row">
            <div class="col-md-12">
                <h4>Buscador de Programas de Verificación</h4>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">

                <div class="card card-accent-success animated fadeIn">
                    <a class="card-header-a" (click)="isCollapsed = !isCollapsed" [attr.aria-expanded]="!isCollapsed"
                        aria-controls="collapseExample">
                        <div class="card-header-buscador">
                            <i class="fa fa-filter"></i> Filtros
                            <i *ngIf="isCollapsed" class="fa fa-caret-down float-right"></i>
                            <i *ngIf="!isCollapsed" class="fa fa-caret-up float-right"></i>
                        </div>
                    </a>
                    <div class="card-body">

                        <div class="collapse group-filtros" id="collapseFiltros" [ngbCollapse]="isCollapsed">

                            <div class="row">
                                <div class="form-group col-md-3">
                                    <label class="col-form-label" for="inpFecha">Fecha Presentación Desde</label>
                                    <p-calendar formControlName="FechaPresentacionDesde" inputStyleClass="form-control" [showIcon]="true" [firstDayOfWeek]="1" dateFormat="dd/mm/yy" appendTo="body"></p-calendar>
                                </div>

                                <div class="form-group col-md-3">
                                    <label class="col-form-label" for="inpFecha">Fecha Presentación Hasta</label>
                                    <p-calendar formControlName="FechaPresentacionHasta" inputStyleClass="form-control" [showIcon]="true" [firstDayOfWeek]="1" dateFormat="dd/mm/yy" appendTo="body"></p-calendar>
                                </div>

                                <div class="form-group col-md-3">
                                    <label class="col-form-label" for="input">Campaña</label>
                                    <ng-select appendTo="body"
                                               [items]="listCampanias"
                                               bindLabel="Descripcion"
                                               bindValue="Id"
                                               formControlName="IdCampania"
                                               loadingText="Cargando..."
                                               [loading]="(!listCampanias || listCampanias.length === 0)"
                                               placeholder="-- Seleccione una Campaña --"
                                               [ngClass]="displayFieldCssNgSelect('IdCampania')"
                                               notFoundText="Campaña no encontrada"
                                               clearAllText="Eliminar selección">
                                        <ng-template ng-option-tmp let-item="item">
                                            <div container="body" ngbTooltip="{{ item.Descripcion }}">{{ item.Descripcion }}</div>
                                        </ng-template>
                                    </ng-select>
                                </div>

                                <div class="form-group col-md-3">
                                    <label class="col-form-label" for="input">Comunidad Autónoma</label>
                                    <ng-select appendTo="body"
                                               [items]="listComunidades"
                                               bindLabel="Descripcion"
                                               bindValue="Id"
                                               formControlName="IdCa"
                                               loadingText="Cargando..."
                                               [loading]="(!listComunidades || listComunidades.length === 0)"
                                               placeholder="-- Seleccione una Comunidad Autónoma --"
                                               [ngClass]="displayFieldCssNgSelect('IdCa')"
                                               notFoundText="Comunidad Autónoma no encontrada"
                                               clearAllText="Eliminar selección">
                                        <ng-template ng-option-tmp let-item="item">
                                            <div container="body" ngbTooltip="{{ item.Descripcion }}">{{ item.Descripcion }}</div>
                                        </ng-template>
                                    </ng-select>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-3">

                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label class="col-form-label" for="inputGrupo">Estado</label>
                                                <div class="input-group-btn-plus">
                                                    <ng-select appendTo="body"
                                                               [items]="listEstadosPv"
                                                               bindLabel="Descripcion"
                                                               bindValue="Id"
                                                               formControlName="IdEstadoPv"
                                                               loadingText="Cargando..."
                                                               [loading]="(!listEstadosPv || listEstadosPv.length === 0)"
                                                               placeholder="-- Seleccione un Estado --"
                                                               [ngClass]="displayFieldCssNgSelect('IdEstadoPv')"
                                                               notFoundText="Estado no encontrado"
                                                               clearAllText="Eliminar selección">
                                                        <!-- una template para el label -->
                                                        <ng-template ng-label-tmp let-item="item">
                                                            <img src="{{ item.Id | IconoEstadoPv }}" ngbTooltip="{{ item.Descripcion }}" />
                                                            <span ngbTooltip="{{ item.Descripcion }}">{{ item.Descripcion }}</span>
                                                        </ng-template>

                                                        <!-- una template para el option -->
                                                        <ng-template ng-option-tmp let-item="item" let-index="index">
                                                            <img src="{{ item.Id | IconoEstadoPv }}" ngbTooltip="{{ item.Descripcion }}" />
                                                            <span ngbTooltip="{{ item.Descripcion }}">{{ item.Descripcion }}</span>
                                                        </ng-template>
                                                    </ng-select>
                                                    <span class="input-group-btn">
                                                        &nbsp;<button name="btnAddEstadoPv" class="btn btn-list btn-secondary" type="button" title="Añade un Estado" (click)="onAddEstadoPv()"><i class="fa fa-plus"></i></button>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <!--ListBox-->
                                    <div class="row">
                                        <div class="col-md-12">
                                            <table class="table table-list table-responsive table-sm">
                                                <tbody>
                                                    <tr *ngFor="let item of listBoxEstadosPv">
                                                        <td scope="col">
                                                            <div class="btn-group">
                                                                <button (click)="onDeleteEstadoPv(item)"
                                                                        class="btn btn-sm btn-danger">
                                                                    <i class="fa fa-remove"></i>
                                                                </button>
                                                            </div>
                                                        </td>
                                                        <td scope="col">
                                                            <img src="{{ item.Id | IconoEstadoPv }}" ngbTooltip="{{ item.Descripcion }}" class="bu-dropdown" />                                                            
                                                        </td>
                                                        <td scope="col" class="td-list">{{item.Descripcion}}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>

                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group-0 float-right">

                                    <div class="btn-group">
                                        <button name="btnSearch" class="btn btn-secondary btn-sm" type="submit"
                                                [disabled]="disableSearchBtn" title="Realiza una búsqueda" (click)="onSearch($event)">
                                            <i class="fa fa-search"></i> Buscar
                                        </button>
                                    </div>

                                    <div class="btn-group">
                                        <button class="btn btn-secondary btn-sm" type="button"
                                                [disabled]="formIsUntouched()"
                                                title="Limpia los filtros" (click)="resetForm($event)">
                                            <i class="fa fa-eraser"></i> Limpiar
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>

    </div>

</form>
